<template lang='pug'>
  .powerful-platform
    //bottom-arch
    website-spacing.whitespace
      v-row(justify='center')
        .display-1.pa-4.grey--text.text--darken-2.text-center Build Tests Where You Are Most Productive
      v-row.mt-10
        v-col(align='center' cols='12' md='6')
          .text-center.mb-10.headline.font-weight-light.grey--text.text--darken-2 Powerful Web-Based IDE
          video(autoplay loop muted width='100%')
            source(src='https://assets.bionicmetrics.com/bionic/webIDE.mp4')
        v-col(align='center' cols='12' md='6')
          .text-center.mb-10.headline.font-weight-light.grey--text.text--darken-2 Powerful CLI
          video(autoplay loop muted width='100%')
            source(src='https://assets.bionicmetrics.com/bionic/CLI.mp4')
      v-row(justify='center')
        .headline.pa-4.grey--text.text--darken-2.text-center From individuals to large automation teams, the Bionic Metrics Platform has you covered wherever and however you want to write tests.
</template>


<script>
import WebsiteSpacing from './WebsiteSpacing';

export default {
  name: 'BuildAnywhere',
  components: {WebsiteSpacing},
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .powerful-platform {
    background-color: #E0F2F1;
  }

  .whitespace {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }
</style>
